import logo from "./logo.svg";
import "./App.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Home from "./components/Home";

function App() {
  const appRouter = createBrowserRouter([
    {
      path: "",
      element: <Home />,
    },
    {
      path: "/page",
      element: <h1>Page</h1>,
    },
  ]);
  return (
    <div>
      <RouterProvider router={appRouter} />
    </div>
  );
}

export default App;
